import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Archive from "@/pages/Archive";
import MapPage from "@/pages/MapPage";
import Definitions from "@/pages/Definitions";
import Timeline from "@/pages/Timeline";
import PyramidDetail from "@/pages/PyramidDetail";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import MyMap from "@/pages/MyMap";
import SharedMap from "@/pages/SharedMap";
import AdminUsers from "@/pages/AdminUsers";
import { ImpersonationBanner } from "@/components/ImpersonationBanner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col bg-background">
          <ImpersonationBanner />
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/archive" element={<Archive />} />
              <Route path="/map" element={<MapPage />} />
              <Route path="/timeline" element={<Timeline />} />
              <Route path="/definitions" element={<Definitions />} />
              <Route path="/pyramid/:slug" element={<PyramidDetail />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/login" element={<Login />} />
              <Route path="/account" element={<Account />} />
              <Route path="/my-map" element={<MyMap />} />
              <Route path="/shared/:token" element={<SharedMap />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
